import { connect } from "react-redux";
import { UserRole } from "../../constants/RoleEnum";
import ResourceApps from "./components/resourceApps";
import ResourceWidgets from "./components/resourceWidgets";
import { useState, useEffect } from "react";

const Resources = (props: any) => {
  const { currentRole } = props;
  const [role, setRole] = useState("");

  useEffect(() => {
    switch (currentRole) {
      case UserRole.Faculty:
        setRole("Faculty");
        break;
      case UserRole.Staff:
        setRole("Staff");
        break;
      case UserRole.Student:
        setRole("Student");
        break;
      default:
        break;
    }
  }, [currentRole]);

  useEffect(() => {
    if (window.location.hash === "#resource-apps") {
      const element = document.getElementById("resource-apps");
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 10);
      }
    }
  }, []);

  return (
    <>
      <div className="row resource-mobile">
        <div className="col-lg-12 mb-3">
          <ResourceWidgets role={role} />
        </div>
        <div className="col-lg-12" id="resource-apps">
          <ResourceApps role={role} />
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
  };
}

export default connect(mapStateToProps, null)(Resources);
